import * as React from 'react'
import { EXPORT_TYPES } from '../../state/constants/index'

interface IExportFormProps {
  filter: string
  onClose: () => void
}

interface IExportFormState {
  fileName: string
  exportType: string
  isLoading: boolean
}

interface IExportTypeSelectorProps {
  exportTypes: string[]
  exportType: string
  onFileTypeChange: (e: any) => void
}

const ExportTypeSelector = (props: IExportTypeSelectorProps) => {
  return (
    <React.Fragment>
      {props.exportTypes.map((exportType: string) => (
        <span className='mr2' key={`radio-csv-${exportType}`}>
          <input
            onChange={props.onFileTypeChange}
            type='radio'
            name='exportType'
            value={exportType}
            checked={props.exportType === exportType}
            id={`radio-csv-${exportType}`}
          />
          <label htmlFor={`radio-csv-${exportType}`} className='h6'>
            {exportType}
          </label>
        </span>
      ))}
    </React.Fragment>
  )
}

//TODO: convert filter and enters string to redirect
class ExportForm extends React.Component<IExportFormProps, IExportFormState> {
  constructor(props: IExportFormProps) {
    super(props)

    this.state = {
      fileName: '' + new Date().toString() + ' - Export',
      exportType: EXPORT_TYPES.EXCEL,
      isLoading: false
    }
  }

  public render() {
    return (
      <form className='flex flex-column'>
        {!this.state.isLoading && (
          <div>
            <div className='flex flex-column mb2'>
              <label className='h6 font-dark-grey mb1' htmlFor='export_file_name'>
                File Name
              </label>
              <input
                id='export_file_name'
                placeholder='untitled'
                name='fileName'
                className='rounded p1 border-light-grey4'
                onChange={this.onFileNameChange}
                value={this.state.fileName}
              />
            </div>
            <div className='mr2 mb3'>
              <ExportTypeSelector
                exportTypes={Object.values(EXPORT_TYPES)}
                exportType={this.state.exportType}
                onFileTypeChange={this.onFileTypeChange}
              />
            </div>
            <div className='right-align'>
              <button type='button' className='btn bg-white rounded font-light-grey mr2' onClick={this.props.onClose}>
                Cancel
              </button>
              <button type='button' className='btn bg-green rounded font-white weight-300' onClick={this.onSubmit}>
                Export
              </button>
            </div>
          </div>
        )}
        {this.state.isLoading && (
          <div className='mx-auto'>
            {/* TODO: Replace this loading label for a proper "loading" animation */}
            <span className='mt3 mb3'>Loading...</span>
          </div>
        )}
      </form>
    )
  }

  private onFileNameChange = (e: any) => {
    this.setState({ fileName: e.target.value })
  }

  private onFileTypeChange = (e: any) => {
    this.setState({ exportType: e.target.value })
  }

  private onSubmit = (e: any) => {
    this.setState({
      isLoading: true
    })
    this.onExport(null).then(
      () => {
        this.setState({
          isLoading: false
        })
        this.props.onClose()
      },
      () => {
        this.setState({
          isLoading: false
        })
        this.props.onClose()
      }
    )
  }

  private onExport = (data: any) => {
    // TODO: Implement export service
    return new Promise<any>((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 1200)
    })
  }
}

export default ExportForm



// WEBPACK FOOTER //
// ./src/components/trips/ExportForm.tsx